import React, { useState } from "react";
import ExclamationIcon from "../../../assets/img/exclamation-mark-icon.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../components/Common/calender-icon.css";
import { dateFormat } from "../../../Helper/common";
import { useDispatch } from "react-redux";
import { saveDateOfJoining } from "../../../Actions/employementActions_v2";
const EmpStatusConfirmationPopup = React.forwardRef((props, ref) => {
  const {
    showModalBox,
    record,
    title,
    description,
    isAdd,
    checkStatus,
    yesOption = "Yes",
    noOption = "No",
    showStatusDOJ = 0,
  } = props;

    const [selectedDate, setSelectedDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const dispatch = useDispatch();

  console.log("hereeee", description);
  const closePopupHandler = () => {
    props.closePopup();
  };

  const proceedHandler = async (e) => {
    e.preventDefault();
    if(showStatusDOJ && selectedDate) {
      let formatedDate = dateFormat("YYYY-MM-DD", selectedDate);
      await dispatch(saveDateOfJoining(formatedDate))
    }
    props.proceedHandler();
  };

  const dateSelectHandler = (date) => {
      setSelectedDate(date);
      //handleSaveDate("01/12/2021");
      // let formatedDate = dateFormat("DD-MM-YYYY", date);
  
      // handleSaveDate(formatedDate);
  
      //
    };

  return (
    <>
      <div
        className={
          "dashboard custom-modal-dialog " +
          (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={closePopupHandler}
      >
        <div
          className="modal-wrapper"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            className="modal-content p-4 no-scroll"
            style={{ maxWidth: "370px" }}
          >
            <div className="text-left">
              <img src={ExclamationIcon} alt="" />
              <h5 className="mt-3">{title}</h5>
              <p className="text-muted">{description}</p>
              {
                !!(showStatusDOJ) && <>
                <span>Enter Date Of Joining<sup className="text-danger">*</sup></span>
                <DatePicker
              key={"DOJ_Status"}
              className="form-control has-icon calendar-icon text-truncate"
              selected={selectedDate || ''}
              id={"DOJ_Status"}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => dateSelectHandler(date)}
              // onFocus={handleThirdPartyFloatingLabel}
              // onBlur={handleThirdPartyFloatingLabel}
              autoComplete="off"
              maxDate={new Date()}
              // minDate={getMinDates()}
              // disabled={isDisabled}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              fixedHeight
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
                </>
              }
            </div>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-between">
                <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                  onClick={closePopupHandler}
                >
                  {noOption}
                </button>
                <button
                  className={
                    isAdd
                      ? "btn btn-success btn-lg btn-block mt-3"
                      : "btn btn-danger btn-lg btn-block mt-3"
                  }
                  disabled={!!(showStatusDOJ && !selectedDate) ? true : false}
                  onClick={
                    checkStatus != 1
                      ? (e) => proceedHandler(e)
                      : (e) => closePopupHandler(e)
                  }
                >
                  {yesOption}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default EmpStatusConfirmationPopup;
